// Guards post-login navigation against open-redirect abuse.
//
// The `redirect` query param on /login is attacker-controllable, and after a
// successful auth it gets handed to window.location.href / router.push — so an
// unvalidated value like `https://evil.example` or `//evil.example` would steer
// a logged-in user off-origin (a phishing pivot).
//
// Two functions, deliberately split by where they're used:
//
//   normalizeRedirectTarget — validate on INGESTION. Returns a same-origin,
//     root-relative path, or null when the target is missing/malformed/
//     off-origin. Use when deciding whether we even have a usable target
//     (query-param consume, or before storing into loginRedirect) so an invalid
//     value is treated as "no target" rather than silently rewritten to '/'
//     (which would clobber a legitimate stored redirect).
//
//   resolveRedirectTarget — resolve at final CONSUMPTION. Same normalization,
//     but falls back to '/' so there is always something safe to navigate to.
export function normalizeRedirectTarget(target) {
  if (!target || typeof target !== 'string') return null
  try {
    // Resolve relative to our origin: absolute URLs keep their own origin
    // (which we then compare), relative paths inherit ours.
    const url = new URL(target, window.location.origin)
    if (url.origin !== window.location.origin) return null
    return `${url.pathname}${url.search}${url.hash}`
  } catch (e) {
    return null
  }
}

export function resolveRedirectTarget(target) {
  return normalizeRedirectTarget(target) || '/'
}
